import React, { JSX } from 'react';
import { TranslationKey } from '../../../../../../types/translation/TranslationKey';
import { t } from '../../../../../../types/translation/Translator';
import { BaseFilter, BaseFilterProps } from '../../../common/BaseFilter';
import { ListIcon } from '../../../../../icons/List/ListIcon';
import AssetTransactionStatusFilterDropdownContent from './Content/AssetTransactionStatusFilterDropdownContent';
import AssetTransactionStatusFilterInnerContent from './Content/AssetTransactionStatusFilterInnerContent';
import { AssetTransactionStatus } from '../../../../../../types/asset_transaction/assetTransaction';
import { itemsContainText } from '../../../../../../util/string.util';

export class AssetTransactionStatusFilter extends BaseFilter<AssetTransactionStatus> {
  constructor() {
    super();
  }

  toLabel(): string {
    return t(TranslationKey.assetStatus).singular.label;
  }

  toCount(props: BaseFilterProps): number {
    return props.filterProps.assetTransactionStatus?.size || 0;
  }

  toIcon(): JSX.Element {
    return <ListIcon className={this.className} />;
  }

  search(item: AssetTransactionStatus, query: string): boolean {
    return itemsContainText(query, [item]);
  }

  toDropdownContent(props: BaseFilterProps): JSX.Element {
    return (
      <AssetTransactionStatusFilterDropdownContent
        filter={this}
        filterProps={props.filterProps}
        setFilterProps={props.setFilterProps}
      />
    );
  }

  toInnerContent(props: BaseFilterProps): string | JSX.Element {
    return (
      <AssetTransactionStatusFilterInnerContent
        filter={this}
        filterProps={props.filterProps}
        setFilterProps={props.setFilterProps}
      />
    );
  }
}
